import { isTargetDomain } from '@/common/utils';
export const getDiscoveryExcludeRoutes = () => {
    const isDiscovery = isTargetDomain('popin');
    // 路由列表中的key
    const excludeRoutes = [];
    return isDiscovery ? excludeRoutes : [];
};